'use client';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function NavBar() {
    const router = useRouter();
    const isHomePage = router.pathname === '/';
    const isMethodPage = router.pathname.startsWith('/methods/');
    const isSymbolsPage = router.pathname === '/symbols';

    const link = (active: boolean) =>
        `inline-flex min-h-[40px] items-center whitespace-nowrap rounded-sm px-3 text-sm transition-colors ${
            active ? 'bg-subtle font-medium text-ink' : 'text-muted hover:text-ink'
        }`;

    return (
        <nav className="sticky top-0 z-[100] flex h-[52px] items-center justify-between gap-3 border-b-[0.5px] border-line bg-white px-4 sm:px-6">
            <Link href="/" className="flex shrink-0 items-center gap-2.5">
                <div className="flex h-7 w-7 items-center justify-center rounded-[6px] bg-purple text-base font-medium text-white">
                    ÷
                </div>
                <span className="text-[15px] font-medium">Maths Tools</span>
            </Link>

            <div className="flex items-center gap-1 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                {isMethodPage ? (
                    <Link href="/" className={link(false)}>
                        ← All tools
                    </Link>
                ) : (
                    <>
                        <Link href="/" className={link(isHomePage && !router.query.section)}>
                            All tools
                        </Link>
                        <Link
                            href="/?section=methods"
                            className={link(router.query.section === 'methods')}
                        >
                            Methods
                        </Link>
                        <Link
                            href="/?section=visualisers"
                            className={link(router.query.section === 'visualisers')}
                        >
                            Visualisers
                        </Link>
                        <Link href="/symbols" className={link(isSymbolsPage)}>
                            Symbols
                        </Link>
                    </>
                )}
            </div>
        </nav>
    );
}
